import type MailboxRequestOptions from 'owa-service/lib/MailboxRequestOptions';
import type RequestOptions from 'owa-service/lib/RequestOptions';
import { createExplicitLogonRequest } from 'owa-headers';
import { getAnchorMailboxFromMailboxInfo } from 'owa-anchormailbox/lib/getAnchorMailboxFromMailboxInfo';

/**
 * Used to attach headers needed for Groups/ Explicit logon scenarios
 * TODO: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/80035/
 * @param mailboxRequestOptions contains MailboxInfo which contains userIdentity (upn of logged in user), mailboxSmtpAddress (upn of mailbox opened) and mailboxType
 * @param useAnchorMailboxFromMailboxInfo when true, the X-AnchorMailbox is derived from the
 * MailboxInfo (OID/PUID routing hint) instead of defaulting to the mailbox SMTP address. Only Group
 * mailboxes opt in; Shared/Teams/Public mailboxes keep the SMTP anchor to avoid changing their routing.
 */
export function getExplicitLogonRequestOptionsV2(
    mailboxRequestOptions: MailboxRequestOptions,
    useAnchorMailboxFromMailboxInfo?: boolean
): RequestOptions {
    return createExplicitLogonRequest(
        mailboxRequestOptions.mailboxInfo.mailboxSmtpAddress,
        mailboxRequestOptions,
        useAnchorMailboxFromMailboxInfo
            ? getAnchorMailboxFromMailboxInfo(mailboxRequestOptions.mailboxInfo)
            : undefined
    );
}
